import { createRoutine } from 'redux-saga-routines';

export const routine = createRoutine('ORDER_SUBMIT_MODAL');
